import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useWindowSize } from '../../hooks/useWindowSize';
import './tutorialStyles.css';

const TutorialStep = ({ children, isVisible, onComplete, currentStep, totalSteps, onSkip }) => (
  <AnimatePresence>
    {isVisible && (
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -50 }}
        transition={{ duration: 0.5 }}
        className="tutorial-overlay"
      >
        <motion.div
          className="tutorial-card"
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          exit={{ scale: 0.8 }}
        >
          {children}
          <div className="flex flex-col gap-2">
            <button
              onClick={onComplete}
              className="tutorial-button"
            >
              {currentStep === totalSteps ? 'Concluir' : 'Próximo'}
            </button>
            <button
              onClick={onSkip}
              className="tutorial-skip-button"
            >
              Pular tutorial
            </button>
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);

const SwipeAnimation = () => (
  <motion.div
    className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
  >
    {/* Mão com dedo indicador */}
    <motion.div
      className="absolute right-8"
      initial={{ x: 0, opacity: 0 }}
      animate={{
        x: -100,
        opacity: [0, 1, 1, 0],
      }}
      transition={{
        duration: 2,
        repeat: Infinity,
        repeatDelay: 1,
        times: [0, 0.2, 0.8, 1]
      }}
    >
      <svg 
      fill="#000000" 
      height="80px" 
      width="80px" 
      version="1.1" 
      id="Layer_1" 
      xmlns="http://www.w3.org/2000/svg" 
      xmlnsXlink="http://www.w3.org/1999/xlink" 
      viewBox="0 0 512 512" 
      xmlSpace="preserve"
    >
      <g transform="translate(1 1)">
        <g>
          <g>
            <path d="M498.321,24.6h-98.987l11.093-11.093c3.413-3.413,3.413-8.533,0-11.947c-3.413-3.413-8.533-3.413-11.947,0l-25.6,25.6     c-3.413,3.413-3.413,8.533,0,11.947l25.6,25.6c1.707,1.707,3.413,2.56,5.973,2.56s4.267-0.853,5.973-2.56     c3.413-3.413,3.413-8.533,0-11.947l-11.093-11.093h98.987c5.12,0,8.533-3.413,8.533-8.533     C506.854,28.013,503.441,24.6,498.321,24.6z"/>
            <path d="M370.321,178.2c-9.387,0-18.773,3.413-25.6,8.533V178.2c0-23.893-18.773-42.667-42.667-42.667     c-9.387,0-18.773,3.413-25.6,8.533c0-23.893-18.773-42.667-42.667-42.667c-9.387,0-18.773,3.413-25.6,8.533V41.667     C208.187,17.773,189.414-1,165.521-1c-23.893,0-42.667,18.773-42.667,42.667v193.707c-18.773-32.427-62.293-48.64-95.573-36.693     c-4.267,0.853-7.68,3.413-11.947,5.973c-12.8,8.533-11.947,19.627-11.947,23.04c-0.853,5.12,0,5.973,11.947,19.627     c14.507,17.067,46.08,52.907,65.707,88.747c1.707,1.707,24.747,39.253,50.347,67.413v22.187c0,46.933,38.4,85.333,85.333,85.333     h85.333c36.693,0,75.093-30.72,83.627-66.56c2.56-10.24,5.12-17.92,8.533-21.333c8.533-10.24,18.773-34.133,18.773-65.707     V220.867C412.987,196.973,394.214,178.2,370.321,178.2z M302.907,493.933h-85.333c-37.547,0-68.267-30.72-68.267-68.267v-7.726     c1.67,1.209,3.366,2.363,5.12,3.459c5.12,4.267,9.387,6.827,14.507,11.093c1.707,0.853,3.413,1.707,5.12,1.707     c2.56,0,5.12-0.853,5.973-3.413c3.413-3.413,2.56-8.533-0.853-11.947c-5.12-5.12-10.24-8.533-15.36-11.947     c-5.914-4.224-11.828-8.451-17.742-13.504c-25.358-26.455-49.672-65.856-49.672-65.856     c-20.48-36.693-52.907-73.387-68.267-91.307c-2.56-3.413-5.973-7.68-7.68-9.387c0-2.56,0-4.267,5.973-7.68     c3.413-1.707,5.973-3.413,8.533-4.267c22.187-7.68,58.88,2.56,75.093,30.72l13.191,19.786c0.109,0.523,0.26,1.041,0.462,1.547     l8.533,17.067c1.707,3.413,4.267,5.12,7.68,5.12c1.707,0,2.56,0,3.413-1.707c3.413-1.707,5.12-6.827,3.413-11.093l-6.02-12.039     c0.028-0.253,0.046-0.507,0.046-0.761V41.667c0-14.507,11.093-25.6,25.6-25.6c14.507,0,25.6,11.093,25.6,25.6v135.68v0.853     v101.547c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533V178.2v-0.853v-33.28c0-14.507,11.093-25.6,25.6-25.6     c14.507,0,25.6,11.093,25.6,25.6V178.2v93.867c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533V178.2     c0-14.507,11.093-25.6,25.6-25.6c14.507,0,25.6,11.093,25.6,25.6v42.667V280.6c0,5.12,3.413,8.533,8.533,8.533     s8.533-3.413,8.533-8.533v-59.733c0-14.507,11.093-25.6,25.6-25.6c14.507,0,25.6,11.093,25.6,25.6V357.4     c0,15.874-3.067,28.674-6.682,37.998c-0.772,0.84-1.403,1.84-1.852,2.962c-3.413,11.093-13.653,13.653-32.427,18.773l-5.12,0.853     c-4.267,0.853-6.827,5.973-5.973,10.24c1.707,3.413,5.12,5.973,8.533,5.973c0.853,0,1.707,0,2.56,0h4.267     c3.922-1.07,7.842-2.104,11.655-3.254c-0.856,2.893-1.618,5.977-2.268,9.228C363.494,469.187,331.921,493.933,302.907,493.933z"/>
          </g>
        </g>
      </g>
    </svg>
    </motion.div>
    
    {/* Texto de instrução */}
    <div className="absolute bottom-1/4 left-0 right-0 text-center pointer-events-none">
      <div className="bg-black bg-opacity-75 text-white py-3 px-6 rounded-lg inline-block">
        <p className="text-lg font-bold">Deslize para navegar na agenda</p>
      </div>
    </div>
  </motion.div>
);

const ProfessionalCards = () => {
  const cards = [
    { name: "João", color: "bg-blue-100" },
    { name: "Maria", color: "bg-green-100" },
    { name: "Pedro", color: "bg-yellow-100" }
  ];

  return (
    <motion.div 
      className="flex overflow-x-auto gap-2 p-2 mb-4"
      initial={{ x: 100 }}
      animate={{ x: 0 }}
      transition={{ duration: 0.5 }}
    >
      {cards.map((card, index) => (
        <motion.div
          key={index}
          className={`flex-shrink-0 ${card.color} p-4 rounded-lg w-24 h-24 flex items-center justify-center text-center`}
          whileHover={{ scale: 1.05 }}
        >
          {card.name}
        </motion.div>
      ))}
    </motion.div>
  );
};

const Confetti = () => {
  const confettiCount = 50;
  const colors = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6'];

  return (
    <div className="fixed inset-0 pointer-events-none z-50">
      {Array.from({ length: confettiCount }).map((_, index) => (
        <motion.div
          key={index}
          className="confetti"
          initial={{
            x: Math.random() * window.innerWidth,
            y: -20,
            backgroundColor: colors[Math.floor(Math.random() * colors.length)]
          }}
          animate={{
            y: window.innerHeight + 20,
            rotate: Math.random() * 720 - 360
          }}
          transition={{
            duration: Math.random() * 2 + 1,
            ease: "linear"
          }}
          style={{
            left: `${Math.random() * 100}%`,
            width: `${Math.random() * 10 + 5}px`,
            height: `${Math.random() * 10 + 5}px`,
          }}
        />
      ))}
    </div>
  );
};

const AddButtonAnimation = () => (
  <motion.div
    className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
  >
    {/* Texto de instrução */}
    <div className="absolute bottom-40 left-0 right-0 text-center">
      <div className="bg-black bg-opacity-75 text-white py-3 px-6 rounded-lg inline-block">
        <p className="text-lg font-bold">Clique no + para criar um agendamento</p>
      </div>
    </div>
  </motion.div>
);

const MobileTutorial = ({ onComplete }) => {
  const [step, setStep] = useState(1);
  const { width } = useWindowSize();
  const isMobile = width < 768;
  const totalSteps = 3;
  const [hasInteracted, setHasInteracted] = useState(false);

  // Adicionar função global para ativar o tutorial
  useEffect(() => {
    window.ativarTutorial = () => {
      localStorage.removeItem('hasTutorialBeenShown');
      window.location.reload();
    };
  }, []);

  // Detectar interação de swipe
  useEffect(() => {
    if (step === 3) {
      let startX = 0;
      let isDragging = false;

      const handleTouchStart = (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
      };

      const handleTouchMove = (e) => {
        if (!isDragging) return;
        
        const currentX = e.touches[0].clientX;
        const diff = startX - currentX;

        // Se o usuário deslizou mais de 50px
        if (diff > 50) {
          setHasInteracted(true);
          // Remover os event listeners imediatamente
          cleanup();
          // Concluir o tutorial após um breve delay para permitir que a animação da agenda termine
          setTimeout(() => {
            onComplete?.();
          }, 800);
        }
      };

      const handleTouchEnd = () => {
        isDragging = false;
      };

      const cleanup = () => {
        document.removeEventListener('touchstart', handleTouchStart);
        document.removeEventListener('touchmove', handleTouchMove);
        document.removeEventListener('touchend', handleTouchEnd);
      };

      document.addEventListener('touchstart', handleTouchStart, { passive: true });
      document.addEventListener('touchmove', handleTouchMove, { passive: true });
      document.addEventListener('touchend', handleTouchEnd, { passive: true });

      return cleanup;
    }
  }, [step, onComplete]);

  // Detectar clique no botão +
  useEffect(() => {
    if (step === 2) {
      const handleClick = (e) => {
        // Procurar por um botão que tenha o texto "+" ou classe que indique que é o botão de adicionar
        const addButton = e.target.closest('button');
        if (addButton && (addButton.textContent.includes('+') || addButton.classList.contains('add-button'))) {
          setStep(3);
        }
      };

      // Adicionar classe de animação ao botão
      const addButton = document.querySelector('button[aria-label="Novo Agendamento"]');
      if (addButton) {
        addButton.classList.add('pulse-animation');
      }

      document.addEventListener('click', handleClick);
      return () => {
        document.removeEventListener('click', handleClick);
        // Remover classe de animação ao limpar
        if (addButton) {
          addButton.classList.remove('pulse-animation');
        }
      };
    }
  }, [step]);

  // Se não estiver em um dispositivo móvel, não mostrar o tutorial
  if (!isMobile) return null;

  const handleStepComplete = () => {
    setStep(step + 1);
  };

  const handleSkip = () => {
    onComplete?.();
  };

  return (
    <>
      {/* Etapa 1: Boas-vindas */}
      <TutorialStep 
        isVisible={step === 1} 
        onComplete={handleStepComplete}
        currentStep={step}
        totalSteps={totalSteps}
        onSkip={handleSkip}
      >
        <div className="text-center">
          <h2 className="text-xl font-bold mb-4">Bem-vindo à sua Agenda!</h2>
          <p className="text-gray-600">
            Vamos te mostrar como usar sua agenda no celular de forma super simples!
          </p>
        </div>
      </TutorialStep>

      {/* Etapa 2: Criar novo agendamento */}
      <AnimatePresence>
        {step === 2 && <AddButtonAnimation />}
      </AnimatePresence>

      {/* Etapa 3: Animação de Swipe */}
      <AnimatePresence>
        {step === 3 && !hasInteracted && <SwipeAnimation />}
      </AnimatePresence>
    </>
  );
};

export default MobileTutorial; 